const mainSearchForm = {
  flights: "Các chuyến bay", // translated 
  tours: "Các tour du lịch", // translated 
  hotel: "Khách sạn", // translated 
  hotels: "Khách sạn", // translated 
  services: "Dịch vụ", // translated 
  search: "TÌM KIẾM", // translated 
  destination: "Điểm đến", // translated 
  includedServices: "Các dịch vụ bao gồm", // translated 
  packageDuration: "Thời lượng gói hàng", // translated 
  checkInOut: "Nhận phòng/trả phòng", // translated 
  guests: "Khách", // translated 
  adults: "Người lớn", // translated 
  children: "Những đứa trẻ", // translated 
  child: "Đứa trẻ", // translated 
  age: "Tuổi", // translated 
  yearsOld: "Tuổi", // translated 
  rooms: "Phòng", // translated 
  close: "Đóng", // translated 
  searchType: "Loại tìm kiếm", // translated 
  accommodation: "Chỗ ở", // translated 
  transfers: "Chuyển nhượng", // translated 
  toursExperiences: "Các tour du lịch/trải nghiệm", // translated 
  nights: "Đêm", // translated 
  days: "Ngày", // translated 
  packageType: "Loại gói", // translated 
  tourType: "Loại hình tour du lịch", // translated 
  packages: "Gói hàng", // translated 
  cars: "Ô tô", // translated 
  cruises: "Du thuyền", // translated 
  infantsInSeat: "Trẻ sơ sinh ngồi trong ghế", // translated 
  infantsOnLap: "Trẻ sơ sinh trên lòng", // translated 
  airport: "Sân bay", // translated 
  passengers: "Hành khách", // translated 
  departureReturn: "Ngày khởi hành và ngày trở về", // translated 
  origin: "Nguồn gốc", // translated 
  roundTrip: "Khứ hồi", // translated 
  isRoundTrip: "Là chuyến đi khứ hồi", // translated 
  dream_packages: "Gói du lịch trong mơ", // translated 
  partying: "Tiệc tùng", // translated 
  thingsToDo: "Những việc cần làm", // translated 
};


export default mainSearchForm;
